import {
  notifyIpAllowlistDenied,
  type TerraApiRoute,
  type TerraApiRouteResponses,
  type TerraApiSuccessBody,
} from '@terra/shared-utils';

const SUCCESS_STATUS_CODES = [200, 201, 204];

export async function terraApiWrapper<
  TRoute extends TerraApiRoute,
  TResponse extends
    TerraApiRouteResponses<TRoute> = TerraApiRouteResponses<TRoute>,
>({
  endpointFn,
  errorHandler,
}: {
  endpointFn: () => Promise<TResponse>;
  errorHandler?: (response: TResponse) => void;
}): Promise<TerraApiSuccessBody<TRoute> | undefined> {
  try {
    const response = await endpointFn();

    if (SUCCESS_STATUS_CODES.includes(response.status)) {
      return response.body;
    }

    notifyIpAllowlistDenied(response.body);
    errorHandler?.(response);
  } catch (error) {
    if (error instanceof Error) {
      throw error;
    }

    throw new Error('Unknown error');
  }
}
